import isPropValid from '@emotion/is-prop-valid';
import 'assets/css/ant.css';
import 'assets/css/fonts.css';
import 'assets/css/loader.css';
import 'bootstrap/dist/css/bootstrap-grid.min.css';
import { ConnectedRouter } from 'connected-react-router';
import moment from 'moment';
import AppPage from 'pages/AppPage';
import ThemeProvider from 'providers/Theme';
import { TooltipProvider } from 'providers/Tooltip';
import React from 'react';
import { IntlProvider } from 'react-intl';
import { Provider } from 'react-redux';
import ScrollToTop from 'react-router-scroll-top';
import { PersistGate } from 'redux-persist/integration/react';
import { ShouldForwardProp, StyleSheetManager } from 'styled-components';

import { history, persistor, store } from './InitStore';

const shouldForwardProp: ShouldForwardProp<'web'> = (propName, target) => {
  if (typeof target === 'string') {
    // For HTML elements, forward the prop if it is a valid HTML attribute
    return isPropValid(propName);
  }
  // For other elements, forward all props
  return true;
};

const locale =
  // @ts-ignore cross browser check.
  window.navigator.userLanguage ||
  window.navigator.language ||
  // @ts-ignore cross browser check.
  window.navigator.browserLanguage ||
  // @ts-ignore cross browser check.
  window.navigator.systemLanguage;

// Sets the moment locale to the browsers default
const setLocale = () => {
  moment.locale(locale);
};

const App = () => {
  // Set global moment locate
  setLocale();

  return (
    <ThemeProvider>
      <Provider store={store}>
        <IntlProvider locale={locale}>
          <ConnectedRouter history={history}>
            <PersistGate loading={null} persistor={persistor}>
              <ScrollToTop />

              <TooltipProvider>
                <StyleSheetManager shouldForwardProp={shouldForwardProp}>
                  <AppPage />
                </StyleSheetManager>
              </TooltipProvider>
            </PersistGate>
          </ConnectedRouter>
        </IntlProvider>
      </Provider>
    </ThemeProvider>
  );
};

export default App;
